import { useEffect, useState } from "react";
import { authClient } from "./authApi";

/**
 * A1-93 (2) — the code version the backend is running now (/api/health's
 * `commit`, the same BUILD_COMMIT stamped onto every calc as
 * `code_commit`). Re-read whenever `dep` changes (the calc on screen), so
 * a deploy made while the page was open is noticed on the next calc load.
 */
export const useAppVersion = (dep) => {
  const [commit, setCommit] = useState(null);
  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await authClient.get("/health");
        if (!cancelled) setCommit(res?.data?.commit || null);
      } catch { /* unknown — the header then says nothing about versions */ }
    })();
    return () => { cancelled = true; };
  }, [dep]);
  return commit;
};

const usable = (v) => !!v && v !== "unknown";

/** "same" | "older" | "unknown". A calc with no code_commit predates the
 *  stamp (roadmap 3.2), so it was made by an earlier version for certain.
 *  Short and full SHAs are compared by prefix. */
export const versionVerdict = (calcCommit, appCommit) => {
  if (!usable(appCommit)) return "unknown";
  if (!calcCommit) return "older";
  if (!usable(calcCommit)) return "unknown";
  const a = String(calcCommit).toLowerCase();
  const b = String(appCommit).toLowerCase();
  return (a.startsWith(b) || b.startsWith(a)) ? "same" : "older";
};

/** Local date + time of an ISO timestamp. The backend writes naive UTC
 *  datetimes (no "Z"), which JS would otherwise read as local time. */
export const fmtLocalDateTime = (iso) => {
  if (!iso) return null;
  const s = String(iso);
  const d = new Date(/[zZ]|[+-]\d\d:?\d\d$/.test(s) ? s : `${s}Z`);
  if (Number.isNaN(d.getTime())) return null;
  return d.toLocaleString(undefined, {
    day: "numeric", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit",
  });
};
